module.exports = __webpack_public_path__ + "static/img/IMG_0905.35dc621.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0905.jpeg
// module id = QRDI
// module chunks = 0